
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/hpe-codewars-code-battle",
      function () {
        return require("private-next-pages/courses/hpe-codewars-code-battle.tsx");
      }
    ]);
  